"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encryptLoginPasswordRsaOaep = encryptLoginPasswordRsaOaep;
function pemSpkiToArrayBuffer(pem) {
    const b64 = pem
        .replace(/-----BEGIN PUBLIC KEY-----/g, "")
        .replace(/-----END PUBLIC KEY-----/g, "")
        .replace(/\s/g, "");
    const binary = atob(b64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes.buffer;
}
async function encryptLoginPasswordRsaOaep(publicKeyPem, password) {
    var _a;
    const subtle = (_a = globalThis.crypto) === null || _a === void 0 ? void 0 : _a.subtle;
    if (!subtle) {
        throw new Error("Web Crypto API is not available");
    }
    const key = await subtle.importKey("spki", pemSpkiToArrayBuffer(publicKeyPem), { name: "RSA-OAEP", hash: "SHA-256" }, false, ["encrypt"]);
    const encrypted = await subtle.encrypt({ name: "RSA-OAEP" }, key, new TextEncoder().encode(password));
    const bytes = new Uint8Array(encrypted);
    let binary = "";
    for (let i = 0; i < bytes.byteLength; i += 1) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}
//# sourceMappingURL=encrypt-password-rsa.js.map